"use strict";
/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLayout = void 0;
const GeneralPath_1 = require("../graphics2d/GeneralPath");
const Rectangle_1 = require("../graphics2d/Rectangle");
//import android.graphics.drawable.shapes.Shape;
//import android.graphics.drawable.shapes.PathShape;
//import android.graphics.Path;
/**
 *
 *
 */
class TextLayout {
    _font;
    _str = "";
    constructor(s, font, frc) {
        this._font = font;
        this._str = s;
        //return;
    }
    getOutline(tx) {
        return new GeneralPath_1.GeneralPath();
    }
    //used by ShapeInfo
    getPixelBounds(frc, x, y) {
        return null;
    }
    getBounds() {
        let width = this._font.getSize() / 2 * this._str.length;
        let height = this._font.getSize();
        let rect = new Rectangle_1.Rectangle(0, 0, width, height);
        return rect;
    }
}
exports.TextLayout = TextLayout;
//# sourceMappingURL=TextLayout.js.map